import { useQuery } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import {
	getRemindersTypesV2,
	type ReminderEntityTypeEnum,
	type ReminderTypeListResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { toReminderEntityWireValue } from "web_myplann/Reminders/Config/reminderEntityWireValues";
import { mapReminderTypeDto } from "web_myplann/Reminders/Mappers/mapReminderTypeDto";
import type {
	ReminderEntity,
	ReminderTemplate,
} from "web_myplann/Reminders/Types/ReminderTypes";

const selectReminderTemplates = (
	data: ReminderTypeListResponseDTO,
): ReminderTemplate[] => (data?.types ?? []).map(mapReminderTypeDto);

export const useReminderTypesQuery = (entity: ReminderEntity) =>
	useQuery({
		queryKey: RemindersKeys.types(entity),
		queryFn: processResponseQuery(() =>
			getRemindersTypesV2(
				// Endpoint čeká hodnotu enumu ("portfolio"), ne název casu, který
				// generovaný typ nabízí - viz reminderEntityWireValues.ts.
				toReminderEntityWireValue(entity.type) as ReminderEntityTypeEnum,
				entity.id,
			),
		),
		select: selectReminderTemplates,
	});
